import { SDKConfig } from "@sdk/default-sdk-config";
import { EntityServices } from "@sdk/utils/entity.service";
import { iWACallLog } from "./wa-call-logs-model";

export class WACallLogsServices {
  configure(config: { basePath?: string; token?: string }) {
    Object.assign(this.config, config);
  }
  constructor(protected config: { basePath: string; token: string }) {
    this.WACallLogs.configure(config);
  }

  WACallLogs = Object.assign(
    new EntityServices<iWACallLog>(SDKConfig, "wa-call-logs"),
    {},
  ) as EntityServices<iWACallLog>;
}
